import { Typography } from "antd";
import { useState } from "react";

const { Paragraph, Text } = Typography;

const InlineExpandableText = ({
  text,
  maxChars = 300,
}: {
  text: string;
  maxChars?: number;
}) => {
  const [expanded, setExpanded] = useState(false);

  const isLong = text?.length > maxChars;
  const displayText =
    !expanded && isLong ? text?.slice(0, maxChars) + "..." : text;
  return (
    <Paragraph
      copyable={{ text }}
      style={{
        whiteSpace: "pre-wrap",
        marginBottom: 0,
        wordBreak: "break-all",
      }}
    >
      {displayText}
      {isLong && (
        <Text
          style={{ marginLeft: 4, cursor: "pointer", color: "#2d58d9" }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "less" : "more"}
        </Text>
      )}
    </Paragraph>
  );
};

export default InlineExpandableText;
